import * as React from 'react';
import Button from '../Components/Button';
import Typography from '../Components/Typography';
import { MainPageLayout } from './MainPageLayout';

const backgroundImage =
	'https://images.unsplash.com/photo-1534854638093-bada1813ca19?auto=format&fit=crop&w=1400';

export const HomePageIntro = () => {
	return (
		<MainPageLayout
			sxBackground={{
				backgroundImage: `url(${backgroundImage})`,
				backgroundColor: '#7fc7d9', // Average color of the background image.
				backgroundPosition: 'center',
			}}
		>
			<Typography
				color="inherit"
				align="center"
				variant="h2"
				marked="center"
			>
				This is my Core Application Home Page
			</Typography>
			<Typography
				color="inherit"
				align="center"
				variant="h5"
				sx={{ mb: 4, mt: { sx: 4, sm: 10 } }}
			>
				Enjoy secret offers up to -70% off the best application in the
				world.
			</Typography>
			<Button
				color="secondary"
				variant="contained"
				size="large"
				component="a"
				href="/signup"
				sx={{ minWidth: 200 }}
			>
				Register
			</Button>
			<Typography variant="body2" color="inherit" sx={{ mt: 2 }}>
				Discover a new experience with this application
			</Typography>
		</MainPageLayout>
	);
};
